import "./AllReports.scss";

import reportBg from "../../../assets/report2.jpg";

import AnnualReports from "./AnnualReports/AnnualReports";
import PriceSensitiveInfo from "./PriceSensitiveInfo/PriceSensitiveInfo";
import QuarterlyReports from "./QuarterlyReports/QuarterlyReports";

const AllReports = () => {
  return (
    <>
      <div className="all_reports">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${reportBg})` }}
            data-aos="fade-down"
          ></div>
          <div className="heading_box">
            <span data-aos="fade-right">Reports</span>
          </div>
          <div className="container  mt-5">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Annual Reports
                </button>
                <button
                  className="nav-link"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  {/* 1st Quarterly Reports */}
                  Quarterly Reports
                </button>
                <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Price Sensitive Information
                </button>

                {/* <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-third"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  3rd Quarterly Reports
                </button> */}
              </div>
            </nav>

            {/* Annual Reports */}

            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <div>
                    <AnnualReports />
                  </div>
                  {/* <div className="table-responsive">
                    <table className="table table-striped report_table">
                      <thead>
                        <tr>
                          <th scope="col">SL No:</th>
                          <th scope="col">Year</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row" className="sl_width">
                            1
                          </th>
                          <td>2024</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2024}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            2
                          </th>
                          <td>2023</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            3
                          </th>
                          <td>2022</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            4
                          </th>
                          <td>2021</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            5
                          </th>
                          <td>2020</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            6
                          </th>
                          <td>2019</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            7
                          </th>
                          <td>2018</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2018}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            8
                          </th>
                          <td>2017</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2017}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                </ul>
              </div>

              {/* !Annual Reports */}

              {/* Quarterly Reports */}
              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <ul className="nav flex-column pdf_list">
                  {/* new design */}
                  <div>
                    <QuarterlyReports />
                  </div>
                  {/* !new design */}
                </ul>
              </div>

              {/* !Quarterly Reports */}

              {/* Price Sensitive Information */}
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <PriceSensitiveInfo />

                  {/* <div className="table-responsive">
                    <table className="table table-striped report_table">
                      <thead>
                        <tr>
                          <th scope="col">SL No:</th>
                          <th scope="col">Year</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <th scope="row" className="sl_width">
                            1
                          </th>
                          <td>2025 Related to (2nd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2025Second}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            2
                          </th>
                          <td>2025 Related to (1st Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2025First}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {1 + indexNumber}
                          </th>
                          <td>
                            Price Sensitive Information (26-04-2025) Related to
                            37th AGM{" "}
                          </td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi37thAgm}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {2 + indexNumber}
                          </th>
                          <td>2024 (Related to 3rd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2024ThirdQuarter}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {3 + indexNumber}
                          </th>
                          <td>2024 (Related to 2nd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2024SecondQuarter}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {4 + indexNumber}
                          </th>
                          <td>2024 (Related to 1st Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2024FirstQuarter}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {5 + indexNumber}
                          </th>
                          <td>
                            Price Sensitive Information (29-04-2024) Related to
                            36th AGM & Dividend Declaration
                          </td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi202404}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {6 + indexNumber}
                          </th>
                          <td>2023 (Related to 3rd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023Third}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {7 + indexNumber}
                          </th>
                          <td>2023 (Related to 2nd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023SecondUnAudit}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {8 + indexNumber}
                          </th>
                          <td>2023 (Related to 1st Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {9 + indexNumber}
                          </th>
                          <td>2023</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023UnAudit}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {10 + indexNumber}
                          </th>
                          <td>2022</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {11 + indexNumber}
                          </th>
                          <td>2021</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {12 + indexNumber}
                          </th>
                          <td>2020</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            {13 + indexNumber}
                          </th>
                          <td>2019</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                </ul>
              </div>
              {/* !Price Sensitive Information */}

              {/*others Information */}
              {/* <div
                className="tab-pane fade"
                id="nav-third"
                role="tabpanel"
                aria-labelledby="nav-third-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      aria-current="page"
                      target="_blank"
                      rel="noreferrer"
                      href={thirdReport2022}
                    >
                      3rd Quarterly Report 2022{" "}
                    </a>
                  </li>
                </ul>
              </div> */}
              {/* !others Information */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllReports;
